module.exports = __webpack_public_path__ + "img/about_con_1-3.875105f8.png";